import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import { BehaviorSubject } from 'rxjs';

@Injectable()

export class ServerService{
  updateServer = new BehaviorSubject(null);
  constructor(private http: HttpClient , private api: AppConfig) {
  }

  checkServer() {
    return this.http.get(this.api.baseUrl + '/checkServer/isOnline');
  }
}
